import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { useScenarios } from './useScenarios'
import { BudgetingScenario } from '../types/BudgetingScenario'
import { ReportDataType } from '../../../redux/context/reports/types'

export const useCtxScenarios = <TData = BudgetingScenario[]>(
  select?: (data: BudgetingScenario[]) => TData,
  dataType?: ReportDataType.forecast | ReportDataType.budget | 'all'
) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useScenarios({ companyId, select, dataType })
}
